const uk = {
    translations: {
        "PagesNames.Cards": "Карти",
        "PagesNames.Operations": "Операції",
        "PagesNames.Devices": "Прилади",
        "PagesNames.Tanks": "Резервуари",
        "PagesNames.Limits": "Ліміти",
        "PagesNames.Administration": "Адміністрування",
        "PagesNames.UserManagement": "Керування користувачами",
        "PagesNames.RoleManagement": "Керування ролями",
        "PagesNames.OrderHistory": "Історія змін",
        "Header.LogoutText": "Вийти",
        "Table.Empty": "Список пустий",
        "Table.saveButton": "Зберегти",
        "Table.cancelButton": "Відміна",
        "Cards.editCardHeader": "Редагування картки",
        "Cards.newCardHeader": "Нова картка",
        "Cards.cardNumber": "Номер карти",
        "Cards.cardRfidNumber": "Номер RFID",
        "Cards.cardIButtonNumber": "Номер iButton",
        "Cards.userName": "Співробітник",
        "Cards.car": "Авто",
        "Cards.description": "Примітка",
        "Cards.cardType": "Тип карти",
        "Cards.avtoCardType": "Авто",
        "Cards.userCardType": "Користувач",
        "Cards.removeCardPopupHeader": "Видалення карти",
        "Cards.removeCardPopupMessage": "Ви дійсно бажаєте видалити карту {card number}",
        "Cards.setOrderNumberPopupHeader": "Введіть номер наряду",
        "Cards.carNumber": "Номер кузова авто",
        "Cards.orderTs": "Дата наряд-замовлення",
        "Cards.barcode": "Штрихкод",
        "CardsPagesNames.Cars": "Автомобілі",
        "CardsPagesNames.Users": "Користувачі",
        "Devices.deviceImei": "Imei приладу",
        "Devices.name": "Ім'я приладу",
        "Devices.description": "Опис",
        "Devices.protocolType": "Тип протоколу",
        "Devices.deviceType": "Тип приладу",
        "Devices.isActive": "Активний",
        "Devices.deviceIoSettings.volumeCountIoId": "Номер датчику об'єму",
        "Devices.deviceIoSettings.volumeRatio": "Коефіцієнт перетворення",
        "Devices.deviceIoSettings.valveIoId": "Номер датчика клапану",
        "Devices.deviceIoSettings.userKeyIoId": "№ датчика читання ключа водія",
        "Devices.deviceIoSettings.autoKeyIoId": "№ датчика читання ключа авто",
        "Devices.withLevelMetterText": "Встановлений рівнемір",
        "Devices.levelMetterSettings.levelMeterInstallHeight": "Висота установки рівнеміра",
        "Devices.levelMetterSettings.temperatureIoId": "Номер датчика температури",
        "Devices.levelMetterSettings.temperatureRatio": "Коефіцієнт перетворення температури",
        "Devices.levelMetterSettings.temperatureDelta": "Дельта зміни температури",
        "Devices.levelMetterSettings.waterLevelMetterIoId": "Номер датчику рівня води",
        "Devices.levelMetterSettings.watterLevelMetterRatio": "Коефіцієнт рівня води",
        "Devices.levelMetterSettings.waterLevelMetterDelta": "Дельта зміни рівня води",
        "Devices.levelMetterSettings.productLevelMetterIoId": "Номер датчику рівня продукту",
        "Devices.levelMetterSettings.productLevelMetterRatio": "Коефіцієнт рівня продукту",
        "Devices.levelMetterSettings.productLevelMetterDelta": "Дельта зміни рівня продукту",
        "Devices.levelMetterSettings.defaultDensity": "Щільність продукту за замовчуванням",
        "Devices.levelMetterSettings.densityIoId": "Номер датчику щільності",
        "Devices.levelMetterSettings.densityRatio": "Коефіцієнт перетворення щільності",
        "Devices.levelMetterSettings.densityDelta": "Дельта зміни щільності",
        "Operations.cardNumber": "Номер карти",
        "Operations.userName": "Механік",
        "Operations.car": "Авто",
        "Operations.operationTs": "Час операції",
        "Operations.startOperationTs": "Час початку операції",
        "Operations.endOperationTs": "Час закінчення операції",
        "Operations.deviceImei": "Імей приладу",
        "Operations.rawVolumeData": "Необроблений об'єм",
        "Operations.volume": "Об'єм",
        "Operations.tankBalance": "Залишок в резервуарі",
        "Operations.limitBalance": "Залишок по ліміту",
        "UserManagement.userName": "Логін користувача",
        "UserManagement.firstName": "Ім'я",
        "UserManagement.secondName": "Прізвище",
        "UserManagement.email": "Почта",
        "UserManagement.isActive": "Активний",
        "UserManagement.roleName": "Роль",
        "UserManagement.newPassword": "Новий пароль",
        "UserManagement.password": "Пароль",
        "UserManagement.confirmPassword": "Підтвердіть пароль",
        "UserManagement.passwordAndConfirmNotEqualsError": "Підтвердження пароля має бути однаковим з паролем",
        "UserManagement.userNameEmptyError": "Ім'я користувача не може бути порожнім",
        "Tanks.tankName": "Резервуар",
        "Tanks.volume": "Об'єм",
        "Tanks.balance": "Залишок",
        "Tanks.minLevel": "Мінімальний об'єм",
        "Tanks.maxLevel": "Максимальний об'єм",
        "Tanks.fuelType": "Тип палива",
        "Tanks.fuelNumber": "Номер палива",
        "Tanks.areaName": "Площадка",
        "Tanks.areaDescription": "Опис",
        "Tanks.department": "Підрозділ",
        "Tanks.usedTankBalance": "Резервуар заповнений на",
        "Tanks.graduations": "Градуювання",
        "Tanks.LoLevelNotificationPopupHeader": "Низький рівень резервуарів",
        "Tanks.LoLevelNotificationPopupMessage": "Низький рівень продукту в резервуарах {tanks}",
        "Tanks.Details.maxLevel": "Об'єм резервуара",
        "Tanks.Details.calculatedVolume": "Розрахунковий залишок",
        "TankOperation.tankName": "Резервуар",
        "TankOperation.userName": "Ім'я користувача",
        "TankOperation.fuelType": "Тип палива",
        "TankOperation.provider": "Постачальник",
        "TankOperation.description": "Коментар",
        "TankOperation.balance": "Відвантажено",
        "TankOperation.deliveryDate": "Час поставки",
        "TankOperation.completed": "Оброблено",
        "TanksPagesNames.Tanks": "Резервуари",
        "TanksPagesNames.TankOperations": "Відвантаження по резервуарам",
        "TanksPagesNames.TanksStateOperations": "Зміна стану резервуарів",
        "TanksOperations.Filter.tankName": "Резервуар",
        "TanksOperations.Filter.dateFrom": "Дата з:",
        "TanksOperations.Filter.dateTo": "Дата по:",
        "TankStateOperation.tankName": "Ім'я резервуару",
        "TankStateOperation.watterLevelHeight": "Рівень води (мм)",
        "TankStateOperation.watterLevelVolume": "Рівень води (л)",
        "TankStateOperation.productLevelHeight": "Рівень продукту (мм)",
        "TankStateOperation.productLevelVolume": "Рівень продукту (л)",
        "TankStateOperation.temperature": "Температура",
        "TankStateOperation.density": "Щільність",
        "TankStateOperation.weight": "Вага",
        "TankStateOperation.packageTs": "Час оновлення",
        "TankStateOperation.densityUnit": "т/м3",
        "TankStateOperation.weightUnit": "т",
        "Operations.Filter.userName": "Співробітник",
        "Operations.Filter.car": "Авто",
        "Operations.Filter.tankName": "Резервуар",
        "Operations.Filter.fuelType": "Тип палива",
        "Operations.Filter.dateFrom": "Дата з:",
        "Operations.Filter.dateTo": "Дата по:",
        "TankStateOperation.Filter.tankName": "Резервуар",
        "TankStateOperation.Filter.dateFrom": "Дата з:",
        "TankStateOperation.Filter.dateTo": "Дата по:",
        "ExtendedIo.ioType": "Тип датчика",
        "ExtendedIo.ioDataType": "Тип данних",
        "ExtendedIo.ioAddress": "Адреса датчика",
        "ExtendedIo.ratio": "Коеффіцієнт",
        "ExtendedIo.offset": "Зміщення",
        "ExtendedIo.dataDelta": "Дельта",
        "ExtendedIo.defaultValue": "Значення за замовчуванням",
        "ExtendedIo.ioDataAction": "Дія конвертації",
        "ExtendedIo.ioDataActionParam": "Параметр конвертації",
        "ExtendedIo.EditTankHeader": "Додаткові датчики",
        "ExtendedIo.watterLevelHeightIoName": "Рівень висоти води",
        "ExtendedIo.watterLevelVolumeIoName": "Рівень об'єму води",
        "ExtendedIo.productLevelHeightIoName": "Рівень висоти продукту",
        "ExtendedIo.producLevelVolumeIoName": "Рівень об'єму продукту",
        "ExtendedIo.productLevelHeightIoQualityName": "Якість сигналу рівня висоти продукту",
        "ExtendedIo.watterLevelHeightIoQualityName": "Якість сигналу рівня висоти води",
        "ExtendedIo.producLevelVolumeIoQualityName": "Якість сигналу рівня об'єму продукту",
        "ExtendedIo.watterLevelVolumeIoQualityName": "Якість сигналу рівня об'єму води",
        "ExtendedIo.temperatureIoName": "Температура",
        "ExtendedIo.temperatureIoQualityName": "Якість сигналу температури",
        "ExtendedIo.densityIoName": "Густина",
        "ExtendedIo.densityIoQualityName": "Якість сигналу густини",
        "ExtendedIo.pressureIoName": "Тиск",
        "ExtendedIo.pressureIoQualityName": "Якість сигналу тиску",
        "ExtendedIo.weightIoName": "Вага",
        "ExtendedIo.weightIoQualityName": "Якість сигналу датчика ваги",
        "Popups.OkButtonText": "Ok",
        "Popups.YesButtonText": "Так",
        "Popups.NoButtonText": "Ні",
        "Popups.CancelButtonText": "Відміна",
        "LoginPage.UserPasswordError": "Логін чи пароль введені невірно",
        "LoginPage.UnknownServerError": "Невідома помилка входу",
        "LoginPage.UserNameText": "Логін:",
        "LoginPage.PasswordText": "Пароль:",
        "LoginPage.LoginButtonText": "Увійти",
        "Limits.cardNumber": "Номер карти",
        "Limits.cardOwnerName": "Авто",
        "Limits.fuelType": "Тип палива",
        "Limits.dayLimit": "Денний ліміт",
        "Limits.monthLimit": "Ліміт на місяць",
        "Limits.dateLimit": "Ліміт",
        "Limits.endDate": "Дата",
        "Limits.limitState": "Використання ліміту",
        "Limits.isEnabled": "Ліміт активний",
        "Limits.notUseLimitState": "Не використовувати ліміти",
        "Limits.useLimitState": "Використовувати ліміти",
        "Limits.stopSupplyState": "Припинити видачу продукту",
        "Limits.cardLimitsHeader": "Ліміти",
        "Limits.dayVolume": "Використано за день",
        "Limits.monthVolume": "Використано за місяць",
        "Limits.totalVolume": "Використано всього",
        "Limits.publisherName": "Хто створив",
        "Limits.orderDate": "Дата ліміту",
        "Limits.mechanicName": "Хто отримав",
        "Limits.isFullyUsed": "Отримано повністю",
        "Limits.isActive": "Активний",
        "Limits.onlyActiveFilter": "Активні",
        "Limits.onlyNotActiveFilter": "Не активні",
        "Limits.activityAllFilter": "Всі",
        "Limits.movingTs": "Дата переміщення",
        "Limits.movingNumber": "Номер переміщення",        
        "AccessLevel.Read": "Читання",
        "AccessLevel.Write": "Запис",
        "RoleManagement.roleName": "Ім'я ролі",
        "RoleManagement.roleDescription": "Опис",
        "RoleManagement.ModuleClaimsTitle": "Доступ до модулів",
        "RoleManagement.FieldClaimsTitle": "Доступ до полів",
        "RoleManagement.roleNameAlreadyExistsError": "Таке ім'я ролі уже є",
        "RoleManagement.removeRolePopupHeader": "Видалення ролі",
        "RoleManagement.removeRolePopupMessage": "Ви впевнені що хочете видалити роль {role name}?",
        "RoleManagement.Claims.Tanks": "Резервуари",
        "RoleManagement.Claims.Areas": "Площадки",
        "RoleManagement.Claims.TankOperations": "Операції резервуарів",
        "RoleManagement.Claims.Cards": "Картки",
        "RoleManagement.Claims.Administration": "Адміністрування",
        "OrderHistory.OrderId": "ID замовлення",
        "OrderHistory.OrderNumber": "Авто/Користувач",
        "OrderHistory.ActionType": "Тип дії",
        "OrderHistory.Description": "Суть змін",
        "OrderHistory.PublisherName": "Хто зробив",
        "OrderHistory.ActionTs": "Час змін"
    }
}

export default uk;